import { AvailabilityTypes, type TranslationStockMapKeys, type TranslationStockMapStatesValues } from './types'

const TOOLTIP_TRANSLATIONS_KEYS = {
  shortageStock: 'ProductAvailability_Stock_ShortageTooltip',
} as const

const STOCK_TRANSLATIONS_KEYS = {
  quantityLeft: 'ProductAvailability_Stock_QuantityLeft',
  bidSuffix: 'ProductAvailability_Stock_BidSuffix',
  inStock: 'ProductAvailability_Stock_InStock',
  shortageStock: 'ProductAvailability_Stock_Shortage',
  supplier: 'ProductAvailability_Stock_Supplier',
  nonInStock: 'ProductAvailability_Stock_NonInStock',
  nonInStockComingSoon: 'ProductAvailability_Stock_NonInStockComingSoon', // used only in NL
  estimatedInStoreCount: 'ProductAvailability_Stock_EstimatedInStoreCount',
  estimatedDeliveryWindowWeeks: 'ProductAvailability_Stock_EstimatedDeliveryWindowWeeks',
  earliestShippingDate: 'ProductAvailability_Stock_EarliestShippingDate'
} as const

export const STOCK_TRANSLATIONS_MAP: Record<TranslationStockMapKeys, string | TranslationStockMapStatesValues> = {
  [AvailabilityTypes.SHOW_ALWAYS_IN_STOCK]: STOCK_TRANSLATIONS_KEYS.inStock,
  [AvailabilityTypes.IMMEDIATE_DOWNLOAD]: {
    default: STOCK_TRANSLATIONS_KEYS.inStock,
    quantityLeft: STOCK_TRANSLATIONS_KEYS.quantityLeft
  },
  [AvailabilityTypes.IN_STOCK_IMMEDIATE_SHIPPING]: STOCK_TRANSLATIONS_KEYS.quantityLeft,
  [AvailabilityTypes.NON_STOCK_ITEM]: STOCK_TRANSLATIONS_KEYS.nonInStock,
  [AvailabilityTypes.NON_STOCK_ITEM_EARLIEST_DATE]: STOCK_TRANSLATIONS_KEYS.earliestShippingDate,
  [AvailabilityTypes.SUPPLIER_STOCK_SHIPPING_WITHIN_48H]: STOCK_TRANSLATIONS_KEYS.supplier,
  [AvailabilityTypes.SUPPLIER_STOCK_SHIPPING_WITHIN_THREE_FOUR_DAYS]: STOCK_TRANSLATIONS_KEYS.supplier,
  [AvailabilityTypes.SUPPLIER_STOCK_SHIPPING_WITHIN_FOUR_SIX_DAYS]: STOCK_TRANSLATIONS_KEYS.supplier,
  [AvailabilityTypes.SUPPLIER_STOCK_SHIPPING_WITHIN_SIX_EIGHT_DAYS]: STOCK_TRANSLATIONS_KEYS.supplier,
  [AvailabilityTypes.SUPPLIER_STOCK_SHIPPING_WITHIN_TEN_TWELVE_DAYS]: STOCK_TRANSLATIONS_KEYS.supplier,
  [AvailabilityTypes.ESTIMATED_IN_STORE_BY_DATE]: STOCK_TRANSLATIONS_KEYS.estimatedInStoreCount,
  [AvailabilityTypes.WEEKS_FROM_ORDER_DATE]: STOCK_TRANSLATIONS_KEYS.estimatedDeliveryWindowWeeks,
  [AvailabilityTypes.PRODUCT_AVAILABILITY_OUT_OF_STOCK_COMING_SOON]: STOCK_TRANSLATIONS_KEYS.nonInStockComingSoon,
  [AvailabilityTypes.NOT_MIGRATED_TYPE]: STOCK_TRANSLATIONS_KEYS.shortageStock,
  [AvailabilityTypes.STOCK_SHORTAGE_ITEM]: {
    default: STOCK_TRANSLATIONS_KEYS.shortageStock,
    tooltip: TOOLTIP_TRANSLATIONS_KEYS.shortageStock
  },
  QUANTITY_LEFT: STOCK_TRANSLATIONS_KEYS.quantityLeft,
  BID_SUFFIX: STOCK_TRANSLATIONS_KEYS.bidSuffix
} as const

const SHIPPING_TRANSLATIONS = {
  withinBusinessDay: 'ProductAvailability_Shipping_WithinBusinessDay',
  withinBusinessDays: 'ProductAvailability_Shipping_WithinBusinessDays',
  toBeConfirmed: 'ProductAvailability_Shipping_ToBeConfirmed',
  isDownloadReady: 'ProductAvailability_Shipping_IsDownloadReady'
} as const

export const SHIPPING_TRANSLATIONS_MAP: Partial<Record<AvailabilityTypes, string>> = {
  [AvailabilityTypes.SHOW_ALWAYS_IN_STOCK]: SHIPPING_TRANSLATIONS.withinBusinessDay,
  [AvailabilityTypes.IMMEDIATE_DOWNLOAD]: SHIPPING_TRANSLATIONS.isDownloadReady,
  [AvailabilityTypes.IN_STOCK_IMMEDIATE_SHIPPING]: SHIPPING_TRANSLATIONS.withinBusinessDay,
  [AvailabilityTypes.NON_STOCK_ITEM]: SHIPPING_TRANSLATIONS.toBeConfirmed,
  [AvailabilityTypes.NON_STOCK_ITEM_EARLIEST_DATE]: SHIPPING_TRANSLATIONS.toBeConfirmed,
  [AvailabilityTypes.SUPPLIER_STOCK_SHIPPING_WITHIN_48H]: SHIPPING_TRANSLATIONS.withinBusinessDays,
  [AvailabilityTypes.SUPPLIER_STOCK_SHIPPING_WITHIN_THREE_FOUR_DAYS]: SHIPPING_TRANSLATIONS.withinBusinessDays,
  [AvailabilityTypes.SUPPLIER_STOCK_SHIPPING_WITHIN_FOUR_SIX_DAYS]: SHIPPING_TRANSLATIONS.withinBusinessDays,
  [AvailabilityTypes.SUPPLIER_STOCK_SHIPPING_WITHIN_SIX_EIGHT_DAYS]: SHIPPING_TRANSLATIONS.withinBusinessDays,
  [AvailabilityTypes.SUPPLIER_STOCK_SHIPPING_WITHIN_TEN_TWELVE_DAYS]: SHIPPING_TRANSLATIONS.withinBusinessDays,
  [AvailabilityTypes.ESTIMATED_IN_STORE_BY_DATE]: SHIPPING_TRANSLATIONS.toBeConfirmed,
  [AvailabilityTypes.WEEKS_FROM_ORDER_DATE]: SHIPPING_TRANSLATIONS.toBeConfirmed,
  [AvailabilityTypes.PRODUCT_AVAILABILITY_OUT_OF_STOCK_COMING_SOON]: SHIPPING_TRANSLATIONS.toBeConfirmed,
} as const

export const SHIPPING_DAYS_MAP: Partial<Record<AvailabilityTypes, string>> = {
  [AvailabilityTypes.SUPPLIER_STOCK_SHIPPING_WITHIN_48H]: '2',
  [AvailabilityTypes.SUPPLIER_STOCK_SHIPPING_WITHIN_THREE_FOUR_DAYS]: '3-4',
  [AvailabilityTypes.SUPPLIER_STOCK_SHIPPING_WITHIN_FOUR_SIX_DAYS]: '4-6',
  [AvailabilityTypes.SUPPLIER_STOCK_SHIPPING_WITHIN_SIX_EIGHT_DAYS]: '6-8',
  [AvailabilityTypes.SUPPLIER_STOCK_SHIPPING_WITHIN_TEN_TWELVE_DAYS]: '10-12',
} as const
